import { useQuery } from '@tanstack/react-query';
import { PairName } from '@ui/assets/config/trade-pair-listings';
import { useDataChainId } from '@ui/hooks/datachain';
import { queryClient } from '@ui/lib/reactQuery';
import { GetPairsVolumeTimeRangeEnum } from '@ui/services/backend/generated/apis';

import { GetPairsQuery, getPairsQuery } from './query';

const getQueryKey = (chainId: number) => ['useBackendPairsAll', chainId];

const getQueryFn = (chainId: number) => async () => {
  const total = (
    await queryClient.ensureQueryData<GetPairsQuery.Response>({
      queryKey: getPairsQuery.getKey({
        chainId,
        size: 1,
        volumeTimeRange: GetPairsVolumeTimeRangeEnum.OneDay,
      }),
      queryFn: getPairsQuery.getFn({
        chainId,
        size: 1,
        volumeTimeRange: GetPairsVolumeTimeRangeEnum.OneDay,
      }),
    })
  ).totalElements;

  const pairs = await queryClient.ensureQueryData<GetPairsQuery.Response>({
    queryKey: getPairsQuery.getKey({
      chainId,
      size: total,
      volumeTimeRange: GetPairsVolumeTimeRangeEnum.OneDay,
    }),
    queryFn: getPairsQuery.getFn({
      chainId,
      size: total,
      volumeTimeRange: GetPairsVolumeTimeRangeEnum.OneDay,
    }),
  });

  return pairs.content;
};

export const useBackendPairsAll = () => {
  const chainId = useDataChainId();

  return useQuery({
    queryKey: getQueryKey(chainId),
    queryFn: getQueryFn(chainId),
  });
};

useBackendPairsAll.getQueryKey = getQueryKey;
useBackendPairsAll.getQueryFn = getQueryFn;

export const useBackendPairByPairName = (pairName: PairName) => {
  const { data } = useBackendPairsAll();

  return data?.[pairName];
};
